const depths = {
  priority: 1000000,
  menu: 9000,
  modal: 8000,
  deepdive: -9999,
};

export default depths;
